import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  Col,
  Divider,
  Flex,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
} from "antd";
import {
  CustomInput,
  CustomSelect,
  CustomButton,
  CustomDynamicSelect,
  CustomTitle,
  AddItemButton,
  CustomParagraph,
} from "../../components";
import deleteRedIcon from "../../assets/images/delete-red.svg";
import { useToken } from "../../common/helper";
import { useSpin } from "../../components/SpinContext";
import { DownOutlined } from "@ant-design/icons";
import {
  AddProducts,
  AddUsers,
  GetProductById,
  GetUserById,
} from "../../api's/onboarding";
import {
  getProductsTypeDDL,
  getTeamsDDL,
  getTeamsDDLOFFeature,
} from "../../common/utils/dropDown";
import TeamsSelector from "../../components/TeamsSelector";
import {
  AssignPermissionOptions,
  commercialValueList,
  stageOfDevelopmentValueList,
  tempratureRangeList,
} from "../../common/static_data";
import PhoneInput from "react-phone-input-2";
import deleteIcon from "../../assets/images/delete.svg";
import { Option } from "antd/es/mentions";
import { PlusOutlined } from "@ant-design/icons";
import TeamsSelectorCheckbox from "../../components/TeamsSelectorCheckbox";
import { useSelector } from "react-redux";

const SettingsProductDrawerForm = ({
  form,
  id,
  handleCloseDrawer,
  handleFetchAllProduct,
}) => {
  const { token, removeToken } = useToken();
  const navigate = useNavigate();
  const { showSpin, hideSpin } = useSpin();
  //   const { id } = useParams();
  const [permissionOptions, setPermissionOptions] = useState(
    AssignPermissionOptions
  );
  const [isFormValid, setIsFormValid] = useState(false);

  //get user by Id
  const [selectedTeams, setSelectedTeams] = useState([]);

  // const teamsOptions = [
  //   { id: 0, name: "Oncology", color: "#F19898" },
  //   { id: 1, name: "Vaccines", color: "#F4D35E" },
  //   { id: 2, name: "Internal medicine", color: "#48C9B0" },
  //   { id: 3, name: "Specialty pharma", color: "#A3E4D7" },
  //   { id: 4, name: "Hospital", color: "#BB8FCE" },
  // ];

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const [isCustomRange, setIsCustomRange] = useState(false);
  const [productTypeDDL, setProductTypeDDL] = useState([]);
  const [isCommercial, setIsCommercail] = useState(false);

  const [temperatureObject, setTemperatureObject] = useState({
    temperature_max: "",
    temperature_min: "",
    temp_range_is_custom: false,
    temperature_unit: "C",
  });

  const teamsList = useSelector((state) => state.teams.list);

  const hasValidTeams = !(
    teamsList.length === 0 ||
    (teamsList.length === 1 && teamsList[0].name.toLowerCase() === "default")
  );

  const [allTeams, setAllTeams] = useState([]);
  // console.log('first , team' , teamsList)
  //get Products type AND teams for drop down
  // console.log('first , allTeams' , allTeams)
  useEffect(() => {
    getProductsTypeDDL(token).then((val) => {
      if (val && val.length > 0) {
        setProductTypeDDL(val);
      }
    });
    getTeamsDDLOFFeature(token, "Products").then((val) => {
      if (val && val.length > 0) {
        setAllTeams(val);
      }
    });
  }, []);
  const requirementKeys = ["shock", "light", "tilt", "pressure", "humidity"];

  //get product by Id
  const GetSingleProductById = (id) => {
    showSpin();
    GetProductById(token, id)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : null;
            if (resp) {
              if (resp?.stage_of_development?.toLowerCase() === "commercial") {
                setIsCommercail(true);
              }
              form.setFieldsValue({
                name: resp.name || "",
                id: resp.id || null,
                product_type: resp.product_type || "",
                stage_of_development: resp.stage_of_development || "",
                commercial_value: resp.commercial_value || "",
                project_id: resp.project_id || "",
                temperature_range: resp.temperature_range || null,
                viability_window: resp.viability_window || null,
                temperature_min: resp.temperature_min || "",
                temperature_max: resp.temperature_max || "",
                temp_range_is_custom: resp.temp_range_is_custom || false,
                temperature_unit: resp.temperature_unit || "",
                teams: resp?.teams || [],
                // add more handling requirements
                shock: resp.shock ?? "",
                light: resp.light ?? "",
                tilt: resp.tilt ?? "",
                pressure_min: resp.pressure_min ?? "",
                pressure_max: resp.pressure_max ?? "",
                pressure_unit: resp.pressure_unit || "",
                humidity_min: resp.humidity_min ?? "",
                humidity_max: resp.humidity_max ?? "",
              });
              //handleTemperatureRangeChange(resp.temperature_range)
              setTemperatureObject({
                temperature_min: resp.temperature_min,
                temperature_max: resp.temperature_max,
                temperature_unit: resp.temperature_unit,
                temp_range_is_custom: resp.temp_range_is_custom,
              });

              const selectedFromBackend = requirementKeys.filter((key) => {
                if (key === "pressure") {
                  return (
                    (resp.pressure_min !== undefined   && resp.pressure_min !== null && resp.pressure_min !== "" ) || 
                    (resp.pressure_max !== undefined &&
                    resp.pressure_max !== null &&
                    resp.pressure_max !== "")
                  );
                }

                if (key === "humidity") {
                  return (
                    (resp.humidity_min !== undefined && resp.humidity_min !== null &&
                    resp.humidity_min !== "") || 
                    (resp.humidity_max !== undefined &&
                    resp.humidity_max !== null &&
                    resp.humidity_max !== "" )
                  );
                }

                return (
                  resp[key] !== undefined &&
                  resp[key] !== null &&
                  resp[key] !== ""
                );
              });

              const selectedCapitalized = selectedFromBackend.map(
                (key) => key.charAt(0).toUpperCase() + key.slice(1)
              );
              setSelectedRequirements(selectedCapitalized);
              setShowDropdown(selectedCapitalized.length === 5);
              setAvailableOptions((prevOptions) =>
                prevOptions.filter((opt) => !selectedCapitalized.includes(opt))
              );

              setIsCustomRange(resp.temp_range_is_custom);
              setSelectedTeams(resp?.teams || []);
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const handleIsCommercial = (value) => {
    setIsCommercail(false);
    if (value && value === "Commercial") {
      setIsCommercail(true);
    }
  };

  useEffect(() => {
    if (id) {
      GetSingleProductById(id);
    }
  }, [id]);

  const handleTemperatureRangeChange = (e) => {
    if (e) {
      if (e === "custom") {
        form.setFieldsValue({
          temp_range_is_custom: true,
          temperature_min: "",
          temperature_max: "",
          temperature_unit: "",
        });
        setIsCustomRange(true);
      } else {
        let obj = tempratureRangeList.find((x) => x.value === e);
        if (obj) {
          setTemperatureObject({
            temperature_min: obj.min,
            temperature_max: obj.max,
            temperature_unit: "C",
            temp_range_is_custom: false,
          });
          setIsCustomRange(false);
        }
      }
    }
  };

  const onFinish = (values) => {
    if (values && Object.keys(values).length > 0) {
      let model = form.getFieldsValue();
      //delete model?.requirement;

      model.id = id ? id : null;
      const teamArray = selectedTeams
        ? selectedTeams.map((item) => item.id)
        : [];
      model.teams = teamArray;

      if (model.temperature_range == "custom") {
        model.temp_range_is_custom = true;
      } else {
        model = { ...model, ...temperatureObject };
      }
      if (
        model.stage_of_development &&
        model?.stage_of_development !== "Commercial"
      ) {
        model.commercial_value = null;
      }
      model.viability_window = !model?.viability_window
        ? null
        : model?.viability_window;
      submitProducts(model);
    }
  };

  const submitProducts = (model) => {
    setIsFormValid(true);
    showSpin();
    AddProducts(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            message.success(data?.data?.message);
            handleFetchAllProduct();
            handleCloseDrawer();
            setSelectedTeams([]);
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
        setIsFormValid(false);
      });
  };

  // default values are set on drawer open
  useEffect(() => {
    form.setFieldsValue({
      teamRoles: [{ team: undefined, role: undefined }],
    });
  }, [form]);

  // const backendData = {
  //   name: "tesm",
  //   product_type: "a327bb4a-a923-43ca-b613-13fe87395c39",
  //   stage_of_development: "Clinical Stage 1",
  //   viability_window: null,
  //   temperature_range: "cryogenic",
  //   teams: [],
  //   id: null,
  //   temperature_min: -180,
  //   temperature_max: -150,
  //   temperature_unit: "C",
  //   temp_range_is_custom: false,
  //   commercial_value: null,

  //   shock: "",
  //   light: "",
  //   tilt: "",
  //   pressure_min: "",
  //   pressure_max: "",
  //   pressure_unit: "",
  //   humidity_min: "",
  //   humidity_max: "",
  // };

  const [selectedRequirements, setSelectedRequirements] = useState([]);
  const [availableOptions, setAvailableOptions] = useState([
    "Shock",
    "Light",
    "Tilt",
    "Pressure",
    "Humidity",
  ]);
  const [showDropdown, setShowDropdown] = useState(false);

  const baseStyle = {
    height: 36,
    width: "100%",
    borderRadius: 8,
    backgroundColor: "#f3f3f3",
    border: "0",
    color: "#5E5E5E",
    paddingLeft: 12,
    paddingRight: 12,
    outline: "none",
  };

  const [selectKey, setSelectKey] = useState(0);
  const renderRequirementField = (type, index) => {

    // const removeItem = () => {
    //   setSelectedRequirements((prev) => prev.filter((_, i) => i !== index));
    //   setAvailableOptions((prev) => [...prev, type].sort());
    // };

    const removeItem = (typeToRemove) => {
      // Remove by type instead of index
      setSelectedRequirements((prev) => prev.filter((t) => t !== typeToRemove));
      // Add back to available options
      setAvailableOptions((prev) => [...prev, typeToRemove].sort());
      // Reset dropdown placeholder
      // let a = form.getFieldValue("requirement")
      // if (a === typeToRemove || availableOptions.length === 0) {
      //   form.setFieldsValue({
      //     requirement: null
      //   })
      //   //setSelectKey((prev) => prev + 1);
      // }


      // Clear form values
      switch (typeToRemove) {
        case "Shock":
        case "Light":
        case "Tilt":
          form.setFieldsValue({ [typeToRemove.toLowerCase()]: null });
          break;
        case "Pressure":
          form.setFieldsValue({
            pressure_min: null,
            pressure_max: null,
            pressure_unit: null,
          });
          break;
        case "Humidity":
          form.setFieldsValue({
            humidity_min: null,
            humidity_max: null,
          });
          break;
        default:
          break;
      }
    };


    const wrapper = {
      display: "flex",
      gap: 8,
      alignItems: "center",
    };

    const renderSimpleInput = (suffix) => (
      <Form.Item
        label={type}
        name={type.toLowerCase()}
        style={{ marginBottom: 16 }}
      >
        <div className="requirement-input-style" style={wrapper}>
          <Form.Item
            name={type.toLowerCase()}
            rules={[
              {
                pattern: /^(?:\d{1,6}|\d{0,5}\.\d{1,6})$/,
                message: "Enter a valid number (max 6 digits total)",
              },
            ]}
            noStyle
          >
            <CustomInput
              placeholder="Enter value"
              height="36px"
              border="0px"
              bgColor="#F3F3F3"
              textColor="#5E5E5E"
              borderRadius="8px"
              placeholderColor="#5E5E5E"
              lineHeight="38px"
              suffixFontWeight="600"
              suffixColor="#000"
              suffix={type === "Shock" ? "G" : type === "Light" ? "lux" : "Deg"}
            />
          </Form.Item>
          <img
            src={deleteIcon}
            alt="delete"
            style={{ cursor: 'pointer' }}
            // style={iconStyle}
            onClick={() => removeItem(type)}
          />
        </div>
      </Form.Item>
    );

    switch (type) {
      case "Shock":
        return renderSimpleInput("G");
      case "Light":
        return renderSimpleInput("lux");
      case "Tilt":
        return renderSimpleInput("Deg");

      case "Pressure":
        return (
          <Form.Item label="Pressure" style={{ marginBottom: 16 }}>
            {/* <div style={wrapper}>
              <Form.Item
                name="pressure_min"
                rules={[
                  {
                    pattern: /^\d*\.?\d*$/,
                    message: "Min should be numeric",
                  },
                ]}
              >
                <CustomInput
                  placeholder="1"
                  height="36px"
                  width={"102px"}
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
              <span>-</span>
              <Form.Item
                name="pressure_max"
                rules={[
                  {
                    pattern: /^\d*\.?\d*$/,
                    message: "Max should be numeric",
                  },
                ]}
              >
                <CustomInput
                  placeholder="10"
                  height="36px"
                  width={"102px"}
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
              <Form.Item name="pressure_unit" noStyle initialValue="psi">
                <Select
                  options={[
                    { label: "psi", value: "psi" },
                    { label: "mbar", value: "mbar" },
                  ]}
                  style={{ ...baseStyle, width: 120 }}
                  dropdownStyle={{ borderRadius: 8 }}
                />
              </Form.Item>
              <img
                src={deleteIcon}
                alt="delete"
                style={{ height: 18, cursor: "pointer" }}
                onClick={removeItem}
              />
            </div> */}

            <div className="requirement-input-style" style={wrapper}>
              <Form.Item
                name="pressure_min"
                noStyle
                rules={[
                  {
                    pattern: /^(100(\.0{1,4})?|[1-9]?\d(\.\d{1,4})?|0(\.0{1,4})?)$/,
                    message: "Min value must be between 0 and 100",
                  },
                ]}
              >
                <CustomInput
                  placeholder="0"
                  height="36px"
                  width={"102px"}
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
              <span>-</span>
              <Form.Item
                name="pressure_max"
                noStyle
                rules={[
                  {
                    //pattern: /^(10(\.0{1,4})?|[1-9](\.\d{1,4})?)$/,
                    pattern: /^(100(\.0{1,4})?|[1-9]?\d(\.\d{1,4})?|0(\.0{1,4})?)$/,
                    message: "Max value must be between 0 and 100",
                  },
                ]}
              >
                <CustomInput
                  placeholder="100"
                  height="36px"
                  width={"102px"}
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
              <Form.Item name="pressure_unit" noStyle initialValue="psi">
                <Select
                  options={[
                    { label: "psi", value: "psi" },
                    { label: "mbar", value: "mbar" },
                  ]}
                  style={{ ...baseStyle, width: 120 }}
                  dropdownStyle={{ borderRadius: 8 }}
                />
              </Form.Item>
              <img
                src={deleteIcon}
                alt="delete"
                style={{ height: 16, cursor: "pointer" }}
                onClick={() => removeItem(type)}
              />
            </div>
          </Form.Item>
        );

      case "Humidity":
        return (
          <>
            <Form.Item label="Humidity" style={{ marginBottom: 16 }}>
              <div className="requirement-input-style" style={wrapper}>
                <Form.Item
                  name="humidity_min"
                 // noStyle
                  rules={[
                    {
                      pattern: /^(100(\.0{1,4})?|[1-9][0-9]?(\.\d{1,4})?)$/,
                      message: "Min value between 1 and 100",
                    },
                  ]}
                >
                  <CustomInput
                    placeholder="1"
                    height="36px"
                    width={"102px"}
                    border="0px"
                    bgColor="#F3F3F3"
                    textColor="#5E5E5E"
                    borderRadius="8px"
                    //placeholderColor="#5E5E5E"
                    lineHeight="38px"
                  />
                </Form.Item>
                <span>-</span>
                <Form.Item
                  name="humidity_max"
                  noStyle
                  rules={[
                    {
                      pattern: /^(100(\.0{1,4})?|[1-9][0-9]?(\.\d{1,4})?)$/,
                      message: "Max value between 1 and 100",
                    },
                  ]}
                >
                  <CustomInput
                    placeholder="100"
                    height="36px"
                    width={"102px"}
                    border="0px"
                    bgColor="#F3F3F3"
                    textColor="#5E5E5E"
                    borderRadius="8px"
                    placeholderColor="#5E5E5E"
                    lineHeight="38px"
                  />
                </Form.Item>
                <Form.Item noStyle>
                  <CustomInput
                    placeholder="%"
                    disabled
                    style={{ ...baseStyle, width: 110 }} // Match Pressure unit width
                  />
                </Form.Item>
                <img
                  src={deleteIcon}
                  alt="delete"
                  style={{ height: 16, cursor: "pointer" }}
                  onClick={() => removeItem(type)}
                />
              </div>
            </Form.Item>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Form
        form={form}
        name="settingsProductForm"
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
        className="drawer-children-h flex flex-col justify-between"
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
        initialValues={{
          name: "",
          product_type: null,
          commercial_value: "",
          temperature_range: null,
          viability_window: null,
          temperature_min: "",
          temperature_max: "",
          temperature_unit: "C",
          pressure_unit: "psi",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "40px",
            paddingTop: "0px",
            left: "0",
            paddingLeft: "32px",
            width: "100%",
            background: "#fff",
            zIndex: "2",
          }}
        >
          <CustomTitle
            text={id ? "Edit product" : "Add product"}
            fontSize={20}
            fontWeight="700"
            lineHeight="32px"
            color="#000"
            marginBottom={0}
          />
        </div>

        <div
          style={{
            flex: 1,
            // overflowY: "auto",
            paddingBottom: "140px",
            paddingTop: "16px",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
          className="custom-scrollbar"
        >
          <Row gutter={[16, 16]}>
            {/* <Col span={24}>
              <CustomParagraph
                text={`Product info`}
                fontSize={15}
                fontWeight={600}
                color="#000"
                lineHeight={"20px"}
                marginBottom={4}
              />
            </Col> */}
            {/* product name  */}
            <Col span={24}>
              <Form.Item
                className="custom-input form-input-style"
                label="Name"
                name="name"
                rules={[
                  { required: true, message: "Please enter product name" },
                  {
                    type: "string",
                    min: 3,
                    message: "Product name must be at least 3 characters long",
                  },
                ]}
                style={{ marginBottom: "0px" }}
              >
                <CustomInput
                  placeholder="Enter product name"
                  height="36px"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
            </Col>
            {/* product type  */}
            <Col span={24}>
              <Form.Item
                className="custom-input form-input-style"
                label="Product type"
                name="product_type"
                style={{ marginBottom: "0px" }}
                rules={[{ required: true, message: "Please select value" }]}
              >
                <CustomDynamicSelect
                  // suffixIcon={<DownOutlined style={{ color: "#5E5E5E" }} />}
                  height="36px"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                  options={productTypeDDL}
                />
              </Form.Item>
            </Col>
            {/* Stage of development */}
            <Col span={24}>
              <Form.Item
                className="custom-input form-input-style"
                label="Stage of development"
                name="stage_of_development"
                style={{ marginBottom: "0px" }}
              >
                <CustomSelect
                  // suffixIcon={<DownOutlined style={{ color: "#5E5E5E" }} />}
                  placeholder="Select"
                  height="36px"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                  onChange={handleIsCommercial}
                  options={stageOfDevelopmentValueList}
                />
              </Form.Item>
            </Col>
            {/* Commercial value */}
            {isCommercial && (
              <Col span={24}>
                <Form.Item
                  className="custom-input form-input-style"
                  label="Commercial value"
                  name="commercial_value"
                  rules={[{ required: true, message: "Please select value" }]}
                  style={{ marginBottom: "0px" }}
                >
                  <CustomSelect
                    // suffixIcon={<DownOutlined style={{ color: "#5E5E5E" }} />}
                    placeholder="Select"
                    height="36px"
                    border="0px"
                    bgColor="#F3F3F3"
                    textColor="#5E5E5E"
                    borderRadius="8px"
                    placeholderColor="#5E5E5E"
                    lineHeight="38px"
                    options={commercialValueList}
                  />
                </Form.Item>
              </Col>
            )}
            {/* project_id */}
            <Col span={24}>
              <Form.Item
                className="custom-input form-input-style"
                label="Project ID"
                name="project_id"
                style={{ marginBottom: "0px" }}
              >
                <CustomInput
                  placeholder="Enter value"
                  height="36px"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Divider style={{ margin: "0px" }} />
            </Col>
            <Col span={24}>
              <CustomParagraph
                noText="-"
                text={`Stability & Handling Requirements`}
                fontSize={15}
                fontWeight={600}
                color="#000"
                lineHeight={"20px"}
                marginBottom={0}
              />
            </Col>
            {/* Transit viability window */}
            <Col span={24}>
              <Form.Item
                className="custom-input form-input-style"
                label="Transit viability window"
                name="viability_window"
                rules={[
                  //{ required: true, message: "Please enter value" },
                  {
                    pattern: /^\d{1,5}$/,
                    message: "Enter up to 5 digits only!",
                  },
                  // {
                  //   validator: (_, value) => {
                  //     const numericValue = parseInt(value, 10);
                  //     if (value && !Number.isInteger(numericValue)) {
                  //       return Promise.reject(
                  //         new Error("Please enter a valid integer")
                  //       );
                  //     }
                  //     return Promise.resolve();
                  //   },
                  // },
                ]}
                style={{ marginBottom: "0px" }}
              >
                <CustomInput
                  placeholder="Enter value"
                  height="36px"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                  suffixFontWeight="600"
                  suffixColor="#000"
                  suffix="hr"
                />
              </Form.Item>
            </Col>
            {/* Temperature range */}
            <Col span={24}>
              <Form.Item
                className="custom-input form-input-style"
                label="Temperature range"
                name="temperature_range"
                rules={[{ required: true, message: "Please select value" }]}
                style={{ marginBottom: "0px" }}
              >
                <CustomSelect
                  // suffixIcon={<DownOutlined style={{ color: "#5E5E5E" }} />}
                  placeholder="Select"
                  height="36px"
                  border="0px"
                  bgColor="#F3F3F3"
                  textColor="#5E5E5E"
                  borderRadius="8px"
                  placeholderColor="#5E5E5E"
                  lineHeight="38px"
                  onChange={handleTemperatureRangeChange}
                  options={tempratureRangeList}
                />
              </Form.Item>
            </Col>
            {/* Custom Temperature Range */}
            {isCustomRange && (
              <>
                <Col span={24}>
                  <Form.Item
                    className="custom-input form-input-style"
                    label="Custom Temperature Range"
                    name=""
                    style={{ marginBottom: "0px", width: "100%" }}
                    dependencies={[
                      "temperature_min",
                      "temperature_max",
                      "temperature_unit",
                    ]}
                    validateTrigger="onSubmit"
                    rules={[
                      {
                        validator: (_, value) => {
                          const customMin =
                            form.getFieldValue("temperature_min");
                          const customMax =
                            form.getFieldValue("temperature_max");
                          const customUnit =
                            form.getFieldValue("temperature_unit");
                          if (!customMin || !customMax || !customUnit) {
                            return Promise.reject(
                              new Error(
                                "Please fill in all custom temperature fields."
                              )
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Row
                      gutter={[8, 0]}
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <Col span={16}>
                        <div
                          className="w-full flex"
                          style={{ display: "flex", alignItems: "center" }}
                        >
                          <Form.Item
                            className="custom-input"
                            name="temperature_min"
                            style={{ width: "98%" }}
                          >
                            <CustomInput
                              placeholder="3"
                              height="36px"
                              width={"100%"}
                              border="0px"
                              bgColor="#F3F3F3"
                              textColor="#5E5E5E"
                              borderRadius="8px"
                              placeholderColor="#5E5E5E"
                              lineHeight="38px"
                            />
                          </Form.Item>

                          <span className="mx-2">-</span>

                          <Form.Item
                            name="temperature_max"
                            style={{ width: "98%" }}
                          >
                            <CustomInput
                              placeholder="13"
                              height="36px"
                              width={"100%"}
                              border="0px"
                              bgColor="#F3F3F3"
                              textColor="#5E5E5E"
                              borderRadius="8px"
                              placeholderColor="#5E5E5E"
                              lineHeight="38px"
                            />
                          </Form.Item>
                        </div>
                      </Col>

                      <Col span={8}>
                        <Form.Item name="temperature_unit">
                          <CustomSelect
                            // suffixIcon={<DownOutlined style={{ color: "#5E5E5E" }} />}
                            placeholder="Temperature unit"
                            width="100%"
                            height="36px"
                            border="0px"
                            bgColor="#F3F3F3"
                            textColor="#5E5E5E"
                            borderRadius="8px"
                            options={[
                              { value: "C", label: "°C" },
                              { value: "F", label: "°F" },
                            ]}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form.Item>
                </Col>
              </>
            )}
            {/* Add more required fields here */}
            {/* rendering fields */}
            {[...selectedRequirements]
              // .sort((a, b) => {
              //   return (
              //     requirementKeys.indexOf(a.toLowerCase()) -
              //     requirementKeys.indexOf(b.toLowerCase())
              //   );
              // })
              .map((item, index) => (
                <Col span={24} key={index}>
                  {renderRequirementField(item, index)}
                </Col>
              ))}

            {/* show add requirement and dropdown  */}
            {showDropdown ? (
              <>
                {availableOptions?.length > 0 &&
                  <Form.Item
                    label="Add requirement"
                    //name="requirement"
                    style={{
                      marginBottom: 0,
                      width: "100%",
                      padding: "0px 8px",
                    }}
                    labelCol={{ span: 24 }} // makes the label appear above the select
                  >
                    <div style={{display:"flex",gap:"8px"}}>
                    <Select
                      key={selectKey}
                      style={{
                        backgroundColor: "#f3f3f3",
                        borderRadius: "8px",
                        height: "36px",
                        // margin: "0 8px",
                        //width: "102px",
                      }}
                      placeholder="Select"
                      onChange={(value) => {
                        setSelectedRequirements([...selectedRequirements, value]);
                        setAvailableOptions(availableOptions.filter((item) => item !== value));
                        setShowDropdown(false)
                      }}
                      options={availableOptions.map((item) => ({
                        label: item,
                        value: item,
                      }))}
                    />
                    <img
                      src={deleteIcon}
                      alt="delete"
                      style={{ cursor: 'pointer' }}
                      // style={iconStyle}
                      onClick={() => setShowDropdown(false)}
                    />
                    </div>
                  </Form.Item>
                }              </>

            ) : (
              <>
                {availableOptions?.length !== 0 &&
                  <div style={{ padding: '8px' }}>

                    <AddItemButton
                      marginTop="0px"
                      fontSize="12px"
                      fontWeight="600"
                      width="28px"
                      height="28px"
                      text={"Add requirement"}
                      onClick={() => setShowDropdown(true)}
                    />
                  </div>}
              </>
            )}
            {/* Add more required fields END here */}
            {/* teams  */}
            {hasValidTeams && (
              <>
                <Col span={24}>
                  <Divider style={{ margin: "0" }} />
                </Col>
                <Col span={24}>
                  <Form.Item
                    className="custom-input form-input-style"
                    label="Teams with access"
                    name="teams"
                    rules={[{ required: true, message: "Please select value" }]}
                  >
                    {/* <CustomParagraph
                    noText="-"
                    text={`Teams with access`}
                    fontSize={13}
                    fontWeight={600}
                    color="#000"
                    lineHeight={"20px"}
                    marginBottom={8}
                  />

                  <TeamsSelectorCheckbox
                    teamsOptions={allTeams}
                    selectedTeams={selectedTeams}
                    setSelectedTeams={setSelectedTeams}
                    onChange={setSelectedTeams}
                  /> */}
                    <TeamsSelector
                      teamsOptions={allTeams}
                      selectedTeams={selectedTeams}
                      onChange={setSelectedTeams}
                      formState={id ? "edit" : "add"}
                    />
                  </Form.Item>
                </Col>
              </>
            )}
          </Row>

          {/* form bottom buttons  */}
          <div
            style={{
              background: "#fff",
              position: "absolute",
              bottom: "0",
              left: "0",
              width: "100%",
              padding: "0 24px 24px",
            }}
          >
            <Row gutter={[0, 8]} style={{ marginTop: "0" }}>
              <CustomButton
                text={"Save"}
                width={"100%"}
                height={48}
                borderRadius={8}
                bgColor={isFormValid ? "#F3F3F3" : "#000"}
                color={isFormValid ? "#A6A6A6" : "#fff"}
                border="0px"
                fontSize={16}
                fontWeight={600}
                htmlType="submit"
                isFormValid={isFormValid}
              />
              <CustomButton
                key="button1"
                width={"100%"}
                onClick={() => handleCloseDrawer()}
                text={"Cancel"}
                bgColor="transparent"
                color="black"
                fontSize="16px"
                fontWeight="600"
                boxShadow="none"
                height="48px"
              />
            </Row>
          </div>
        </div>
      </Form>
    </>
  );
};

export default SettingsProductDrawerForm;
